let _extratoLinhas = [];
let _extratoSessaoAtual = null;

function extratoContaSelecionada(){
  const id=document.getElementById('extrato-conta')?.value||'';
  return contasFinanceirasAtivas().find(c=>String(c.id)===id||String(c.nome)===id)||null;
}
function extratoFormatoAtual(){
  return document.getElementById('extrato-formato')?.value||'ofx';
}
function selecionarFormatoExtrato(fmt){
  const el=document.getElementById('extrato-formato');if(el)el.value=fmt;
  atualizarAjudaFormatoExtrato();
}
function atualizarAjudaFormatoExtrato(){
  const fmt=extratoFormatoAtual();
  const txt={
    ofx:'OFX é o formato recomendado: possui transações estruturadas e pode trazer FITID para evitar duplicidade.',
    csv:'CSV exige conferência porque cada banco usa colunas e separadores diferentes. Use o modelo quando possível.',
    pdf:'PDF é importação assistida: revise todas as linhas e valide saldos antes de confirmar.',
    texto:'Texto colado é importação manual assistida: nenhuma linha não compreendida será descartada sem prévia.'
  }[fmt]||'Revise as transações antes de confirmar.';
  const el=document.getElementById('extrato-formato-ajuda');if(el)el.textContent=txt;
  atualizarResumoContaExtrato();
}
function atualizarResumoContaExtrato(){
  const c=extratoContaSelecionada(),fmt=extratoFormatoAtual();
  const banco=document.getElementById('extrato-banco-info'),tipo=document.getElementById('extrato-tipo-conta-info'),res=document.getElementById('extrato-conta-resumo'),wrap=document.getElementById('extrato-confirm-manual-wrap');
  if(banco)banco.value=c?.instituicao||c?.nome||'';
  if(tipo)tipo.value=c?.tipo||'';
  const manual=c&&['caixa','manual'].includes(String(c.tipo||c.status||'').toLowerCase());
  if(wrap)wrap.style.display=manual&&fmt!=='texto'?'block':'none';
  if(res)res.innerHTML=c?`Conta selecionada: <strong>${escapeHtml(c.nome)}</strong> · ${escapeHtml(c.instituicao||'sem instituição')} · ${escapeHtml(c.tipo||'tipo não informado')} · ${escapeHtml(c.status||'manual')}${manual&&fmt!=='texto'?'<br><span style="color:var(--warn)">Atenção: extrato bancário normalmente não deve ser importado em caixa físico/manual.</span>':''}`:'Cadastre ou selecione uma conta financeira antes de importar.';
}
function validarContaExtratoAntesDeProcessar(formato,arquivoNome=''){
  const c=extratoContaSelecionada();
  if(!c){toast('Selecione a conta financeira correspondente ao extrato.','error');return false}
  const tipo=String(c.tipo||'').toLowerCase(),status=String(c.status||'').toLowerCase();
  const contaManual=tipo==='caixa'||tipo==='manual'||status==='manual'&&String(c.nome||'').toLowerCase().includes('caixa');
  if(contaManual&&formato!=='texto'&&!document.getElementById('extrato-confirm-manual')?.checked){
    toast('Este extrato pertence a uma instituição financeira e não pode ser importado para caixa físico/manual sem confirmação especial.','error');
    atualizarResumoContaExtrato();
    return false;
  }
  if(arquivoNome&&formato==='pdf')toast('PDF exige revisão obrigatória antes da confirmação.','info');
  return true;
}
function extratoHashTexto(text){
  let h=2166136261;for(let i=0;i<String(text).length;i++){h^=text.charCodeAt(i);h=Math.imul(h,16777619)}return (h>>>0).toString(16);
}
function criarSessaoImportacaoExtrato({formato,arquivo='',texto='',linhas=[]}){
  const conta=extratoContaSelecionada();
  const valores=linhas.map(l=>Number(l.val)||0);
  const datas=linhas.map(l=>l.date).filter(Boolean).sort();
  _extratoSessaoAtual={
    id:'imp_ext_'+Date.now(),
    arquivo,
    hashArquivo:extratoHashTexto(texto||arquivo||JSON.stringify(linhas)),
    contaId:conta?.id||conta?.nome||'',
    conta:conta?.nome||'',
    banco:conta?.instituicao||'',
    formato,
    periodoInicio:datas[0]||'',
    periodoFim:datas[datas.length-1]||'',
    linhas:linhas.length,
    creditos:valores.filter(v=>v>0).reduce((s,v)=>s+v,0),
    debitos:Math.abs(valores.filter(v=>v<0).reduce((s,v)=>s+v,0)),
    status:'aguardando_revisao',
    usuario:(CACHE.config||{}).consultor||'Operador',
    createdAt:new Date().toISOString()
  };
  return _extratoSessaoAtual;
}
function chaveExtratoMovimento(x){
  const fitid=x.fitid||x.identificadorBancario;
  if(fitid)return ['fitid',x.conta||'',fitid].join('|');
  const desc=String(x.descricaoOriginal||x.desc||'').trim().toLowerCase().replace(/\s+/g,' ');
  return [x.data,x.conta||'',Number(x.valor||0).toFixed(2),desc].join('|');
}
function baixarModeloCSVExtrato(){
  const linhas=[['Data','Descricao original','Documento','Credito','Debito','Valor','Saldo','Identificador'],['10/07/2026','PIX RECEBIDO CLIENTE X','PIX123','5000,00','','','15000,00','FITID123'],['11/07/2026','PAGAMENTO BOLETO XYZ','CP0042','','1240,00','','13760,00','FITID124']];
  const csv=linhas.map(r=>r.map(v=>`"${String(v).replace(/"/g,'""')}"`).join(';')).join('\r\n');
  const blob=new Blob([csv],{type:'text/csv;charset=utf-8'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='modelo-importacao-extrato-gaturamo.csv';document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
function handleDropExtrato(ev){
  ev.preventDefault();ev.currentTarget.style.borderColor='var(--border)';
  const file=ev.dataTransfer?.files?.[0];if(!file)return;
  selecionarFormatoExtrato((file.name.split('.').pop()||'').toLowerCase()==='csv'?'csv':'ofx');
  const input=document.getElementById('ofx-file');
  if(input){const dt=new DataTransfer();dt.items.add(file);input.files=dt.files;importarArquivo(input);}
}

function conciliacaoOptions(linha){
  const valor=Math.abs(Number(linha.val)||0),entrada=linha.val>=0;
  const fonte=entrada?DB.get('recebiveis').filter(x=>x.status!=='recebido'):DB.get('pagamentos').filter(x=>x.status!=='pago');
  const candidatos=fonte.filter(x=>Math.abs((Number(x.valor)||0)-valor)<0.01).slice(0,12);
  return `<option value="">— Não conciliar —</option>`+candidatos.map(x=>`<option value="${entrada?'recebiveis':'pagamentos'}|${escapeHtml(x.id)}">${escapeHtml(entrada?(x.cliente+' · '+(x.desc||'')):(x.desc||''))} · ${fmt(x.valor)}</option>`).join('');
}

function renderExtratoReview(linhas){
  _extratoLinhas = linhas;
  const el = document.getElementById('extrato-preview');
  if(!el) return;
  if(!linhas.length){el.innerHTML=`<div style="color:var(--muted);text-align:center;padding:24px">Nenhuma transação encontrada. Verifique o formato.</div>`;return;}

  const conta=extratoContaSelecionada(),contaNome=conta?.nome||document.getElementById('extrato-conta')?.value||'';
  const existentes=new Set(DB.get('lancamentos').map(chaveExtratoMovimento));
  linhas.forEach(l=>{l.conta=contaNome;l.situacao=existentes.has(chaveExtratoMovimento({...l,valor:Math.abs(l.val)}))?'Possível duplicidade':'Nova';});
  const sessao=_extratoSessaoAtual||criarSessaoImportacaoExtrato({formato:extratoFormatoAtual(),linhas});
  const cats = ['A classificar','Venda','Entrada de pedido','Outros recebimentos','Transferência interna','Tarifa bancária','Aluguel','Água','Energia','Folha de pagamento','Máquina','Software','Material','Frete','Manutenção','Consultoria','Impostos','CapEx','OpEx','Outros'];

  el.innerHTML = `
    <div class="panel" style="margin-bottom:12px">
      <div class="panel-header"><h3>3. Validação da origem</h3><small style="color:var(--muted)">Sessão ${escapeHtml(sessao.id)} · ${escapeHtml(sessao.formato.toUpperCase())}</small></div>
      <div class="cards">
        <div class="card"><label>Linhas lidas</label><div class="val">${linhas.length}</div></div>
        <div class="card green"><label>Créditos</label><div class="val">${fmt(sessao.creditos)}</div></div>
        <div class="card red"><label>Débitos</label><div class="val">${fmt(sessao.debitos)}</div></div>
        <div class="card warn"><label>Duplicidades</label><div class="val">${linhas.filter(l=>l.situacao!=='Nova').length}</div></div>
      </div>
      <div style="font-size:12px;color:var(--muted);margin-top:8px">A descrição original do banco será preservada para auditoria. Use a descrição interna apenas para organizar a gestão.</div>
    </div>
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px">
      <div style="font-weight:700;font-size:15px">📋 ${linhas.length} transações encontradas. Revise antes de confirmar</div>
      <div style="display:flex;gap:8px">
        <button class="btn btn-ghost btn-sm" onclick="toggleTodas(true)">Selecionar todas</button>
        <button class="btn btn-ghost btn-sm" onclick="toggleTodas(false)">Desmarcar todas</button>
        <button class="btn btn-primary" onclick="importarSelecionadosComDedup()">Confirmar revisão</button>
      </div>
    </div>
    <div style="overflow-x:auto">
    <table style="width:100%;border-collapse:collapse;font-size:13px">
      <thead><tr style="border-bottom:2px solid var(--border)">
        <th style="padding:8px;text-align:left;width:32px"><input type="checkbox" id="chk-todos" checked onchange="toggleTodas(this.checked)" style="width:15px;height:15px"></th>
        <th style="padding:8px;text-align:left;min-width:80px">Data</th>
        <th style="padding:8px;text-align:left;min-width:260px">Descrição original</th>
        <th style="padding:8px;text-align:left;min-width:240px">Descrição interna</th>
        <th style="padding:8px;text-align:left;min-width:140px">Tipo</th>
        <th style="padding:8px;text-align:left;min-width:180px">Categoria</th>
        <th style="padding:8px;text-align:left;min-width:130px">Situação</th>
        <th style="padding:8px;text-align:left;min-width:230px">Conciliar com</th>
        <th style="padding:8px;text-align:left;min-width:150px">Ação</th>
        <th style="padding:8px;text-align:right;min-width:100px">Valor</th>
      </tr></thead>
      <tbody id="extrato-tbody">
      ${linhas.map((l,i)=>`<tr style="border-bottom:1px solid var(--border)" id="extrato-row-${i}">
        <td style="padding:8px"><input type="checkbox" class="extrato-chk" data-idx="${i}" ${l.importar?'checked':''} style="width:15px;height:15px"></td>
        <td style="padding:8px;white-space:nowrap">${fmtData(l.date)}</td>
        <td style="padding:8px;color:var(--text);font-size:12px">${escapeHtml(l.descricaoOriginal||l.desc||'')}${l.fitid?`<br><small style="color:var(--muted)">FITID: ${escapeHtml(l.fitid)}</small>`:''}</td>
        <td style="padding:8px"><input class="si extrato-desc-interna" data-idx="${i}" value="${escapeHtml(l.descricaoInterna||l.desc||'')}" style="font-size:12px;padding:5px 8px"></td>
        <td style="padding:8px">
          <select class="si extrato-tipo" data-idx="${i}" onchange="atualizarLinhaExtrato(${i})" style="font-size:12px;padding:4px 8px">
            <option value="entrada" ${l.tipo==='entrada'?'selected':''}>↑ Entrada</option>
            <option value="saida" ${l.tipo==='saida'?'selected':''}>↓ Saída</option>
            <option value="transferencia" ${l.tipo==='transferencia'?'selected':''}>Transferência</option>
          </select>
        </td>
        <td style="padding:8px">
          <select class="si extrato-cat" data-idx="${i}" style="font-size:12px;padding:4px 8px">
            ${cats.map(c=>`<option ${c===l.cat?'selected':''}>${c}</option>`).join('')}
          </select>
        </td>
        <td style="padding:8px"><span class="badge" style="${l.situacao==='Nova'?'':'background:var(--warn);color:#111'}">${escapeHtml(l.situacao)}</span><br><small style="color:var(--muted)">${escapeHtml(l.confianca||'sem correspondência')}</small></td>
        <td style="padding:8px"><select class="si extrato-match" data-idx="${i}" style="font-size:11px;padding:4px 8px">${conciliacaoOptions(l)}</select></td>
        <td style="padding:8px"><select class="si extrato-acao" data-idx="${i}" style="font-size:11px;padding:4px 8px"><option value="criar">Criar pendência/lançamento</option><option value="conciliar">Conciliar selecionado</option><option value="transferencia">Marcar transferência</option><option value="ignorar">Ignorar com auditoria</option><option value="duplicada" ${l.situacao!=='Nova'?'selected':''}>Marcar duplicada</option></select></td>
        <td style="padding:8px;text-align:right;font-weight:700;color:${l.val>=0?'#00d4aa':'#f06595'};white-space:nowrap">
          ${l.val>=0?'+':''}${fmtMoney(Math.abs(l.val))}
        </td>
      </tr>`).join('')}
      </tbody>
    </table>
    </div>
    <div style="display:flex;justify-content:flex-end;margin-top:16px">
      <button class="btn btn-primary" onclick="importarSelecionadosComDedup()">✅ Confirmar importação revisada</button>
    </div>`;
}

function atualizarLinhaExtrato(i){
  const tipo = document.querySelector(`.extrato-tipo[data-idx="${i}"]`)?.value;
  _extratoLinhas[i].tipo = tipo;
  _extratoLinhas[i].descricaoInterna = document.querySelector(`.extrato-desc-interna[data-idx="${i}"]`)?.value||_extratoLinhas[i].descricaoInterna||_extratoLinhas[i].desc||'';
}

function toggleTodas(v){
  document.querySelectorAll('.extrato-chk').forEach(c=>c.checked=v);
  document.getElementById('chk-todos').checked=v;
}

async function importarSelecionadosComDedup(){
  const lancamentos = [...DB.get('lancamentos')];
  const contaObj=extratoContaSelecionada();
  const contaExtrato=contaObj?.nome||document.getElementById('extrato-conta')?.value||'Extrato bancário';
  if(!validarContaExtratoAntesDeProcessar(extratoFormatoAtual()))return;
  const existentes=new Set(lancamentos.map(chaveExtratoMovimento));
  let count = 0,duplicados=0,ignorados=0,transferencias=0;const conciliados=[];
  document.querySelectorAll('.extrato-chk:checked').forEach(chk=>{
    const i = parseInt(chk.dataset.idx);
    const l = _extratoLinhas[i];
    const catEl = document.querySelector(`.extrato-cat[data-idx="${i}"]`);
    const tipoEl = document.querySelector(`.extrato-tipo[data-idx="${i}"]`);
    const matchEl = document.querySelector(`.extrato-match[data-idx="${i}"]`);
    const acaoEl = document.querySelector(`.extrato-acao[data-idx="${i}"]`);
    const descInternaEl = document.querySelector(`.extrato-desc-interna[data-idx="${i}"]`);
    const acao=acaoEl?.value||'criar';
    if(acao==='ignorar'){ignorados++;return}
    if(acao==='duplicada'){duplicados++;return}
    const cat = catEl?.value||l.cat;
    const tipo = tipoEl?.value||l.tipo;
    const item={
      id:'lan_ext_'+Date.now()+'_'+i,
      tipo:acao==='transferencia'?'transferencia':tipo,
      cat,
      desc:(descInternaEl?.value||l.descricaoInterna||l.desc||'').slice(0,120),
      descricaoOriginal:l.descricaoOriginal||l.desc||'',
      descricaoInterna:descInternaEl?.value||l.descricaoInterna||l.desc||'',
      linhaOriginal:l.linhaOriginal||'',
      identificadorBancario:l.fitid||l.identificadorBancario||'',
      documento:l.documento||'',
      valor:Math.abs(l.val),
      data:l.date,
      conta:contaExtrato,
      contaId:contaObj?.id||contaExtrato,
      origem:'extrato',
      importacaoId:_extratoSessaoAtual?.id||'',
      conciliado:false,
      createdAt:new Date().toISOString()
    };
    if(acao==='transferencia'){item.cat='Transferência interna';item.conciliado=true;transferencias++;}
    if(matchEl?.value&&acao!=='transferencia'){const[col,id]=matchEl.value.split('|');item.conciliadoCom={colecao:col,id};item.conciliado=true;conciliados.push({col,id,lancamentoId:item.id,data:item.data});}
    const k=chaveExtratoMovimento(item);
    if(existentes.has(k)){duplicados++;return}
    existentes.add(k);lancamentos.push(item);
    count++;
  });
  if(!count){toast(duplicados?'Todos os itens selecionados já foram importados.':'Selecione ao menos um lançamento.','error');return}
  const alteracoes=[{key:'lancamentos',value:lancamentos}];
  const sessoes=[...DB.get('extrato_importacoes')];
  const sessao={...(_extratoSessaoAtual||criarSessaoImportacaoExtrato({formato:extratoFormatoAtual(),linhas:_extratoLinhas})),status:'confirmado',importadas:count,conciliadas:conciliados.length,ignoradas:ignorados,rejeitadas:0,duplicadas:duplicados,transferencias,confirmadoEm:new Date().toISOString()};
  const si=sessoes.findIndex(s=>s.id===sessao.id);if(si>=0)sessoes[si]=sessao;else sessoes.unshift(sessao);
  alteracoes.push({key:'extrato_importacoes',value:sessoes.slice(0,100)});
  if(conciliados.length){
    const recs=DB.get('recebiveis'),pags=DB.get('pagamentos');
    conciliados.forEach(m=>{const lista=m.col==='recebiveis'?recs:pags,idx=lista.findIndex(x=>x.id===m.id);if(idx>=0){lista[idx].status=m.col==='recebiveis'?'recebido':'pago';lista[idx][m.col==='recebiveis'?'recebidoEm':'pagoEm']=m.data;lista[idx].lancamentoId=m.lancamentoId;lista[idx].conciliadoEm=new Date().toISOString();}});
    alteracoes.push({key:'recebiveis',value:recs},{key:'pagamentos',value:pags});
  }
  await DB.commit(alteracoes);
  await auditar('criar','lancamentos',`Importação bancária ${sessao.id}: ${count} movimento(s), ${conciliados.length} conciliado(s), ${duplicados} duplicado(s), ${ignorados} ignorado(s)`,null,sessao);
  for(const m of conciliados.filter(x=>x.col==='recebiveis'))await criarNotaFiscalPendenteDeRecebivel(m.id,m.lancamentoId,{silent:true});
  await registrarLogIntegracao('bancario','importou_extrato',`Confirmou importação ${sessao.id} de ${contaExtrato}; ${count} movimento(s)`,sessao);
  document.getElementById('extrato-preview').innerHTML=`<div style="text-align:center;padding:32px">
    <div style="font-size:48px">✅</div>
    <div style="font-size:18px;font-weight:700;margin-top:12px">Importação confirmada com revisão</div>
    <div style="color:var(--muted);margin-top:6px">${count} movimento(s) criado(s), ${conciliados.length} conciliado(s), ${transferencias} transferência(s), ${duplicados} duplicado(s), ${ignorados} ignorado(s).</div>
    <button class="btn btn-primary" style="margin-top:16px" onclick="showPage('caixa')">Ver no Caixa</button>
  </div>`;
  document.getElementById('extrato-paste-area').value='';
  toast(`${count} lançamentos importados ✅`);
}
const importarSelecionados=importarSelecionadosComDedup;

function importarArquivo(input){
  const file = input.files[0];
  if(!file) return;
  const ext = file.name.split('.').pop().toLowerCase();
  const formato=(ext==='ofx'||ext==='qif')?'ofx':ext==='csv'?'csv':'texto';
  selecionarFormatoExtrato(formato);
  if(!validarContaExtratoAntesDeProcessar(formato,file.name)){input.value='';return}
  const reader = new FileReader();
  reader.onload = e => {
    const text = e.target.result;
    let txns = [];
    if(ext==='ofx'||ext==='qif') txns = parseOFX(text);
    else txns = parseCSV(text);
    const linhas=txnsToReview(txns);
    criarSessaoImportacaoExtrato({formato,arquivo:file.name,texto,linhas});
    renderExtratoReview(linhas);
    toast(`${txns.length} transações lidas do arquivo`);
  };
  reader.readAsText(file, ext==='csv'?'UTF-8':'ISO-8859-1');
  input.value='';
}

function importarPDF(input){
  const file = input.files[0];
  if(!file) return;
  selecionarFormatoExtrato('pdf');
  if(!validarContaExtratoAntesDeProcessar('pdf',file.name)){input.value='';return}
  criarSessaoImportacaoExtrato({formato:'pdf',arquivo:file.name,texto:file.name,linhas:[]});
  toast('PDF é assistido: cole o texto abaixo e revise todas as linhas antes de confirmar.','info');
  // For PDF, guide user to paste text since we can't run pdfjs
  document.getElementById('extrato-paste-area').focus();
  document.getElementById('extrato-paste-area').placeholder='Abra o PDF, selecione todo o texto (Ctrl+A), copie (Ctrl+C) e cole aqui...';
  input.value='';
}

function processarTextoExtrato(){
  const text = document.getElementById('extrato-paste-area')?.value||'';
  if(!text.trim()){toast('Cole o texto do extrato primeiro','error');return;}
  selecionarFormatoExtrato(extratoFormatoAtual()==='pdf'?'pdf':'texto');
  if(!validarContaExtratoAntesDeProcessar(extratoFormatoAtual()))return;
  // Try OFX first, then free text
  let txns = text.includes('<OFX>')||text.includes('<STMTTRN>') ? parseOFX(text) : parseTextoLivre(text);
  if(!txns.length) txns = parseCSV(text);
  const linhas=txnsToReview(txns);
  criarSessaoImportacaoExtrato({formato:extratoFormatoAtual(),texto,linhas});
  renderExtratoReview(linhas);
  if(txns.length) toast(`${txns.length} transações identificadas`);
  else toast('Nenhuma transação encontrada. Tente outro formato','error');
}

function previewExtrato(){
  // Live preview count
  const text = document.getElementById('extrato-paste-area')?.value||'';
  const out=document.getElementById('extrato-live-preview');
  if(out)out.textContent=text.trim()?`${text.split('\n').filter(x=>x.trim()).length} linha(s) no texto colado`:'';
  if(text.length < 20) return;
}

function renderExtrato(){
  preencherSelectContaExtrato();
  atualizarAjudaFormatoExtrato();
  // Just reset when navigating to page
  if(!document.getElementById('extrato-preview')?.innerHTML?.trim()){
    // nothing to do
  }
}


